import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/components/Login'
import Acceso from '@/components/Acceso'
import Lobby from '@/components/Lobby'
import Sala from '@/components/Sala'
import Chat from '@/components/Chat'
import Atencion from '@/components/Atencion'


Vue.use(VueRouter)

const routes = [
  { name: 'Login', path: '/Login', component: Login },
  { name: 'Acceso', path: '/Acceso', component: Acceso },
  { name: 'Lobby', path:'/Lobby', component: Lobby },
  { name: 'Sala', path:'/Sala', component: Sala },
  { name: 'Chat', path:'/Chat/:keyId', component: Chat },
  { name: 'Atencion', path:'/Atencion/:keyId', component: Atencion },
]

const router = new VueRouter({
    routes 
})

export default router